var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowUp = function SvgArrowUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 7.825-4.9 4.9q-.3.3-.7.287a1 1 0 0 1-.7-.312q-.275-.3-.288-.7a.92.92 0 0 1 .288-.7l6.6-6.6q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l6.6 6.6a.93.93 0 0 1 .275.688q0 .412-.275.712-.3.3-.713.3a.97.97 0 0 1-.712-.3L13 7.825V19q0 .424-.287.712A.97.97 0 0 1 12 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 19z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowUp);
export { ForwardRef as ReactComponent };